import { render } from "./StoreOnboardingStepGeneralInfo.vue?vue&type=template&id=68b55bc8"
import script from "./StoreOnboardingStepGeneralInfo.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepGeneralInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__